module.exports = __webpack_public_path__ + "img/currency-euro.5bd46a58.svg";